module.exports = __webpack_public_path__ + "static/img/case.4d871277.svg";